import { ENDING_RARITY_META } from "@storyline/shared";
import { Handle, type NodeProps, Position } from "@xyflow/react";
import type { EndingFlowNodeItem } from "@/src/stories/utils/graph-view";

const EndingNode: React.FC<NodeProps<EndingFlowNodeItem>> = ({ data: { ending }, selected }) => {
	return (
		<div
			className={`flex w-52 flex-col gap-1 rounded-xl border border-dashed bg-glass p-3 ${selected ? "border-accent-lav" : "border-border-soft"}`}
		>
			<Handle type="target" position={Position.Top} />
			<span className="font-semibold text-foreground text-sm">🏁 {ending.name}</span>
			<span className="text-muted text-xs">
				Fin {ending.endingNumber} · {ENDING_RARITY_META[ending.rarity].label}
			</span>
		</div>
	);
};

export default EndingNode;
